module.exports = __webpack_public_path__ + "static/media/new-linux.367f9810.svg";